/**
 * Where the snippet goes on each site builder. Instructions are short on
 * purpose: the snippet goes in the page head once, and every platform has
 * one screen for that. The words live in SIGNUP.GATE.PLATFORM.<KEY>.
 */
export const INSTALL_PLATFORMS = [
    { id: 'shopify', key: 'SHOPIFY', steps: 4 },
    { id: 'woocommerce', key: 'WORDPRESS', steps: 3 },
    { id: 'prestashop', key: 'PRESTASHOP', steps: 3 },
    { id: 'wix', key: 'WIX', steps: 3 },
    { id: 'squarespace', key: 'SQUARESPACE', steps: 3 },
    { id: 'gtm', key: 'GTM', steps: 4 },
    { id: 'other', key: 'OTHER', steps: 2 },
] as const;

export type InstallPlatformId = (typeof INSTALL_PLATFORMS)[number]['id'];

/**
 * The tab to open first, from what the website check detected
 * ("Shopify", "woocommerce", "WordPress", "wix.com"…). Unknown → "Other".
 */
export function platformTab(detected?: string | null): InstallPlatformId {
    const p = (detected || '').toLowerCase();
    if (!p) return 'other';
    if (p.includes('shopify')) return 'shopify';
    if (p.includes('woo') || p.includes('wordpress') || p === 'wp') return 'woocommerce';
    if (p.includes('presta')) return 'prestashop';
    if (p.includes('wix')) return 'wix';
    if (p.includes('squarespace')) return 'squarespace';
    if (p.includes('gtm') || p.includes('tag manager')) return 'gtm';
    return 'other';
}
